import { Component, OnInit, OnDestroy } from '@angular/core';
import { Field } from 'ng-formly';
import { IMyOptions } from 'mydaterangepicker';
import * as _ from "lodash";
import { PlatformApp } from '../../services/app.service';

@Component({
    selector: 'daterangepicker',
    template: ` 
  <div class="form-group">
    <div class="input-group">
      <my-date-range-picker name="id" [options]="myDateRangePickerOptions" 
                    [(ngModel)]="model[key]"  ></my-date-range-picker>
    </div>
  </div>
  `,
})
export class DateRangePicker extends Field implements OnInit, OnDestroy {
    myDateRangePickerOptions: IMyOptions = {
        // other options...
        dateFormat: 'dd.mmm.yyyy',
        selectionTxtFontSize: '12px',
        width: '100%'
    };
    values;
    subscriptions: any = [];
    formulae = [];
    modelValues = [];

    ngOnInit() {

        if (!this.form['newcontrols'])
            this.form['newcontrols'] = {};

        for (var key in this.form.controls) {
            this.form['newcontrols'][key] = this.form.controls[key];
        }

        if (this.field['formulae']) {
            this.formulae = this.field['formulae'];

            // Create Form level Array
            if (!this.form['subscribed'])
                this.form['subscribed'] = [];

            // Subscription for Current Field
            if (this.field.formControl) {
                if (!_.includes(this.form['subscribed'], this.field.key)) {
                    this.form['subscribed'].push(this.field.key);
                    this.addWatcher(this.field.formControl);
                }
            }
            else
                console.log('Missing DateRange : ' + this.field.key);
        }
    }

    private addWatcher(formControl) {
        this.subscriptions.push(formControl.valueChanges.subscribe((updatedValue: any) => {
            for (var i = 0; i < this.formulae.length; i++) {
                var formula = this.formulae[i];
                if (this.setModelValues(formula['fields'], updatedValue)) {
                    this.setResults(formula['results'], PlatformApp.processData(formula['formula'], this.modelValues));
                }
            }
        }));
    }

    private setModelValues(fieldArray, updatedValue) {
        var requiredFieldsExist = true;
        this.modelValues = [];
        for (var j = 0; j < fieldArray.length; j++) {
            if (!this.model[fieldArray[j]]) {
                requiredFieldsExist = false;
            } else {
                if (fieldArray[j] == this.field.key) {
                    this.modelValues.push(updatedValue);
                } else {
                    this.modelValues.push(this.model[fieldArray[j]]);
                }
            }
        }
        return requiredFieldsExist;
    }
    private setResults(resultArray, value): void {
        for (var i = 0; i < resultArray.length; i++) {
            var resultField = resultArray[i];
            if (this.form.controls[resultField]) {
                this.form.controls[resultField].setValue(value);
            } else {
                if (this.form['newcontrols'][resultField]) {
                    this.form['newcontrols'][resultField].setValue(value);
                } else {
                    this.model[resultField] = value;
                }
            }
        }
    }

    ngOnDestroy() {
        for (var i = 0; i < this.subscriptions.length; i++) {
            this.subscriptions[i].unsubscribe();
        }

    }




}



// WEBPACK FOOTER //
// ./src/app/shared/components/fields/daterangepicker.ts